<template>
  <div class="form-horizontal">
    <form method="post" @submit.prevent="doRegister">
    <h3 class="text-center m-b-20">{{ $t('login.register') }}</h3>
      <div class="button-group">
        <div class="form-group">
          <div class="col-xs-12">
            <input-text
              type="text"
              :value="form.r_name"
              placeholder="Name"
              @input="text => { setField({ key: 'r_name', value: text }) }"
              :errors="error.r_name"
            />
          </div>
        </div>
        <div class="form-group">
          <div class="col-xs-12">
            <input-text
              type="text"
              :value="form.r_email"
              placeholder="Email"
              @input="text => { setField({ key: 'r_email', value: text }) }"
              :errors="error.r_email"
            />
          </div>
        </div>
        <div class="form-group">
          <div class="col-xs-12">
            <input-text
              type="password"
              :value="form.r_password"
              placeholder="Password"
              @input="text => { setField({ key: 'r_password', value: text }) }"
              :errors="error.r_password"
            />
          </div>
        </div>
        <div class="form-group">
          <div class="col-xs-12">
            <input-text
              type="password"
              :value="form.r_re_password"
              placeholder="Confirm Password"
              @input="text => { setField({ key: 'r_re_password', value: text }) }"
              :errors="error.r_re_password"
            />
          </div>
        </div>
        <div class="text-danger mb-4" v-if="errorSignUp">
          <small>{{ errorSignUp }}</small>
        </div>
        <div class="form-group">
          <form-button
            type="primary"
            inputType="submit"
            :text="$t('login.register')"
            :loading="loadingSignUp"
            :block="true"
            :click="() => {}"
            class="btn btn-lg btn-block btn-info btn-rounded"
          />
        </div>
        <div class="line-center text-center my-3">
          <span>{{ $t('common.or') }}</span>
        </div>
      </div>
    </form>
    <div class="form-group">
      <div class="col-sm-12 text-center">
        {{ $t('login.already_has_account') }}
        <router-link
          :to="{ name: 'login' }"
          class="text-info m-l-5"
          aria-expanded="false"
        >
          {{ $t('login.sign_in') }}
        </router-link>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import InputText from '@/components/Form/InputText';
import LinkButton from "@/components/Misc/LinkButton";
import FormButton from '@/components/Form/FormButton';
import Modal from "@/components/Misc/Modal";

export default {
  name: "register",
  components: {
    InputText,
    LinkButton,
    FormButton,
    Modal,
  },
  props: ["stayAfter"],
  computed: {
    ...mapGetters({
      form: 'auth/form',
      loadingSignUp: 'auth/loadingSignUp',
      error: 'auth/errorForm',
      errorSignUp: 'auth/errorSignUp',
    }),
  },
  methods: {
    ...mapActions({
      register: 'auth/register',
      ssoLogin: "auth/ssoLogin",
      setField: 'auth/setField',
    }),
    async doRegister() {
      await this.register();
    },
  },
};
</script>
<style scoped>
.line-center {
  border-bottom: 1px solid #e0e1e2;
  line-height: 0.1em;
  margin: 10px 0 20px;
}

.line-center span {
  background: #fff;
  padding: 0 10px;
}
</style>